import styled from 'styled-components';
import { MdStar, MdStarBorder } from 'react-icons/md';

export const Container = styled.div`
    display:flex;
    flex-direction: column;
    height:100%;
    width:100%;
    padding: 15px;
    overflow-y:auto;

    > h1 {
        margin-bottom: 15px;
    }
`;

export const ContainerDisclaimer = styled.div`
    display:flex;
    width:100%;
    flex-direction:column;
    align-content:center;
    margin-bottom: 15px;
    flex: auto 1 0;
    align-items:center;

    > span:last-child{
        color: red;
    }
`;

export const Disclaimer = styled.span`
    display:flex;
    flex: auto 1 0;
    text-align:center;
    font-weight: 400;
    margin-bottom: 5px;
    font-size: 16px;
`;

export const ContainerPerguntas = styled.div`
    width:100%;
    display:flex;
    flex-direction:column;
    align-content: center;
    flex:auto 1 0;
`;

export const Pergunta = styled.div`
    width:100%;
    display:flex;
    flex-direction:column;
    align-content: center;
    text-align:center;
    margin-bottom: 15px;
    flex:auto 1 0;

    > article {
        color: #404040;
    }
    > article h3 {
        color: #404040;
        font-weight: 400;
    }
`;

export const Estrelas = styled( MdStarBorder )`
    font-size: 30px;
    cursor:pointer;
    ${ props => props.valoratual >= props.valor ? 'fill: #ff9800;' : '' }
    :hover{
        fill: #ff9800;
    }
`;

